import { Component, OnInit, WritableSignal } from '@angular/core';
import { SharedDataService } from 'src/app/shared/services/shared-data.service';
import { BaseComponent } from 'src/app/shared/components/base/base.component';
import { AppResource } from 'src/app/app.resource';
import { CommonModule } from '@angular/common';
import { ProgressCircleComponent } from 'src/app/shared/components/progress-circle/progress-circle.component';
import { LayoutInfo } from 'src/app/shared/models/model/concretes/components/layout-info.model';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  standalone: true,
  imports: [CommonModule, ProgressCircleComponent]
})
export class HeaderComponent extends BaseComponent implements OnInit {
  step: WritableSignal<number>;
  stepShow: WritableSignal<number>;
  maxStep: WritableSignal<number>;
  maxStepShow: WritableSignal<number>;
  layoutInfo: WritableSignal<LayoutInfo | undefined>;
  progress: WritableSignal<number>;

  constructor(
    resources: AppResource,
    private sharedDataService: SharedDataService
  ) {
    super(resources);
    this.step = this.sharedDataService.getStep();
    this.stepShow = this.sharedDataService.getStepShow();
    this.maxStep = this.sharedDataService.getMaxStep();
    this.maxStepShow = this.sharedDataService.getMaxStepShow();
    this.layoutInfo = this.sharedDataService.getLayoutInfo();
    this.progress = this.sharedDataService.getProgress();
  }
}
